import type { SportSuggestionAction, ThresholdKind, ThresholdSport } from '@painpal/contracts';
import type { PowerCurveWindow, SportFilter, ZoneSource } from './keys';

export const activityPath = (id: string): string => `/api/activities/${encodeURIComponent(id)}`;
export const thresholdPath = (id: string): string => `/api/thresholds/${encodeURIComponent(id)}`;
export const thresholdsPath = (sport: ThresholdSport, kind: ThresholdKind): string => `/api/thresholds?sport=${sport}&kind=${kind}`;
export const powerCurvePath = (id: string, window: PowerCurveWindow): string => `${activityPath(id)}/power-curve?window=${window}`;

export function activitiesPath(sport: SportFilter, cursor: string | null): string {
  const params = new URLSearchParams();
  if (cursor !== null) params.set('cursor', cursor);
  if (sport !== 'all') params.set('sport', sport);
  const query = params.toString();
  return query === '' ? '/api/activities' : `/api/activities?${query}`;
}

export function fitnessPath(from: string | null, to: string): string {
  return from === null ? `/api/fitness?to=${to}` : `/api/fitness?from=${from}&to=${to}`;
}

export const weekPath = (start: string, sport: SportFilter = 'all'): string =>
  (sport === 'all' ? `/api/weeks/${start}` : `/api/weeks/${start}?sport=${sport}`);

export const planPath = (from: string, to: string): string => `/api/plan?from=${from}&to=${to}`;
export const planDayPath = (date: string): string => `/api/plan/${date}`;
export const PLAN_COPY_PATH = '/api/plan/copy';

export function weeklyZonesPath(from: string | null, to: string, source: ZoneSource, sport: SportFilter = 'all'): string {
  const params = new URLSearchParams();
  if (from !== null) params.set('from', from);
  params.set('to', to);
  params.set('model', source);
  if (sport !== 'all') params.set('sport', sport);
  return `/api/zones/weekly?${params.toString()}`;
}

export const THRESHOLD_SUGGESTIONS_PATH = '/api/thresholds/suggestions';
// The sport actions are the contract's SPORT_SUGGESTION_ACTIONS (Task 8); re-exported for the mutations.
export type { SportSuggestionAction };
export type SuggestionAction = 'ftp/accept' | 'ftp/dismiss' | 'max-hr/accept' | 'max-hr/dismiss' | `${SportSuggestionAction}/${'accept' | 'dismiss'}`;
export const suggestionActionPath = (action: SuggestionAction): string => `${THRESHOLD_SUGGESTIONS_PATH}/${action}`;
